// extracted by extract-css-chunks-webpack-plugin
module.exports = {"seller-directory":"seller-directory___UQboA","global-regions":"global-regions____4p2L"};